import { Injectable } from '@angular/core';
import { IID_OLOPOPSVLAN } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDolVlanQuery } from './iidOlVlan.query';
import { IIDolVlanStore } from './iidOlVlan.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({ providedIn: 'root' })
@InterfaceDataService(InterfaceName.IID_OLO_POP_SVLAN)
export class IIDolVlanService extends CrudService<IID_OLOPOPSVLAN, IIDolVlanStore, IIDolVlanQuery> {
  constructor(
    protected store: IIDolVlanStore,
    public query: IIDolVlanQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(
      Topics.IID_OLO_POP_SVLAN,
      store,
      query,
      actionService,
      updateStrategy
    );
  }
}
